import { DateTime } from 'luxon';

const parseDate = (dateString: string, fromFormat: string, toFormat: string = 'MMMM dd, y') => {
  const parsedDate = DateTime.fromFormat(dateString, fromFormat);
  return parsedDate.toFormat(toFormat);
}

export default parseDate;